export default __webpack_public_path__ + "static/media/package-box.ddb0e3ab.svg";